import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { DeviceDetectorService } from './device-detector/device-detector.service';

@Injectable({ providedIn: 'root' })
export class PlatformService {
  public deviceDetector = inject(DeviceDetectorService);
  platformId = inject(PLATFORM_ID);

  isMobile(): boolean {
    if (isPlatformServer(this.platformId)) {
      return true;
    }

    return this.deviceDetector.isMobile() || this.deviceDetector.isTablet();
  }

  isScreen(): boolean {
    if (isPlatformServer(this.platformId)) {
      return false;
    }

    return !this.deviceDetector.isMobile() && !this.deviceDetector.isTablet();
  }

  isTablet(): boolean {
    return this.deviceDetector.isTablet();
  }

  isPhone(): boolean {
    if (isPlatformServer(this.platformId)) {
      return true;
    }

    return this.deviceDetector.isMobile();
  }

  isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  isSafari(): boolean {
    return this.deviceDetector.userAgent.includes('Safari');
  }
}
